import { useState } from "react";
import {
    Dialog, DialogContent, DialogHeader, DialogTitle,
} from "../components/ui/dialog";
import { Question, ArrowRight } from "@phosphor-icons/react";

const FLOW = [
    { name: "Streams", desc: "define what we monitor.", to: "/streams" },
    { name: "Sources", desc: "are the conversations we find.", to: "/sources" },
    { name: "Raw Signals", desc: "are what people actually say.", to: "/signals" },
    { name: "Analyses", desc: "interpret the patterns.", to: "/analyses" },
    { name: "Insights", desc: "save what matters.", to: "/insights" },
    { name: "Briefing", desc: "shows what matters right now.", to: "/" },
    { name: "Content Ideas", desc: "turn intelligence into usable output.", to: "/content-ideas" },
];

export default function HowThisWorks({ trigger }) {
    const [open, setOpen] = useState(false);
    return (
        <>
            {trigger ? (
                <span onClick={() => setOpen(true)} className="cursor-pointer">{trigger}</span>
            ) : (
                <button
                    type="button"
                    onClick={() => setOpen(true)}
                    data-testid="how-this-works-trigger"
                    className="inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-[0.18em] text-white/60 hover:text-white border border-white/15 hover:border-accent px-2.5 py-1.5 rounded-sm w-full justify-center"
                >
                    <Question size={11} weight="duotone" />
                    How this works
                </button>
            )}
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent data-testid="how-this-works-modal" className="rounded-sm max-w-xl">
                    <DialogHeader>
                        <DialogTitle className="font-display text-2xl tracking-tight">
                            How HAEVN Intelligence works
                        </DialogTitle>
                        <p className="text-xs text-muted-foreground mt-1">The product flow, end to end.</p>
                    </DialogHeader>
                    <ol className="space-y-3 mt-4">
                        {FLOW.map((step, i) => (
                            <li key={step.name} className="flex items-start gap-3 group">
                                <span className="font-mono text-[10px] tabular-nums text-muted-foreground/60 pt-1 w-6">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <div className="flex-1 pb-3 border-b border-border last:border-b-0">
                                    <div className="flex items-baseline gap-2">
                                        <span className="font-display font-bold text-lg text-foreground">{step.name}</span>
                                        <span className="editorial text-[15px] text-muted-foreground leading-snug">
                                            {step.desc}
                                        </span>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ol>
                    <div className="mt-2 pt-4 border-t border-border flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.18em] text-muted-foreground flex-wrap">
                        {FLOW.map((s, i) => (
                            <span key={s.name} className="inline-flex items-center gap-1.5">
                                <span className={i === 5 ? "text-primary" : ""}>{s.name}</span>
                                {i < FLOW.length - 1 && <ArrowRight size={9} className="text-muted-foreground/40" />}
                            </span>
                        ))}
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}
